import { useState, useMemo } from 'react';
import {
  LandingBrand,
  LandingBrandPlacementListingTypeEnum
} from '../graphql/types';
import {
  ProjectCard,
  ProjectsGridFilterType
} from '../components/PashaLanding/types';
import { filterProjectsGridItems } from '../utils/helpers/filterProjectsGridItems';

export function usePashaProjectsGridHook(landingBrand?: LandingBrand | null) {
  const [filter, setFilter] = useState<ProjectsGridFilterType>('ALL');

  const projects: ProjectCard[] = useMemo(
    () =>
      (landingBrand?.placements || []).map(placement => ({
        image: placement.coverUrl || '',
        title: placement.name,
        address: placement.address,
        forSale:
          placement.listingType === LandingBrandPlacementListingTypeEnum.Sale,
        forRent:
          placement.listingType === LandingBrandPlacementListingTypeEnum.Rent,
        url: placement.path || placement.url || '#'
      })),
    [landingBrand]
  );

  const filtered = useMemo(
    () => filterProjectsGridItems(projects, filter),
    [projects, filter]
  );

  return { filter, setFilter, projects, filtered };
}
